const getZen = () => {
  return (window as any).zE;
};

const Zendesk = {
  zen: (): any => getZen(),
  reset: (): void => {
    getZen()("webWidget", "reset");
  },
  setSuggestions: (value: string): void => {
    getZen()("webWidget", "helpCenter:setSuggestions", { search: value });
  },
  setUrlSuggestions: (): void => {
    getZen()("webWidget", "helpCenter:setSuggestions", { url: true });
  },
  show: (): void => {
    const zen = getZen();
    if (zen) zen("webWidget", "show");
  },
  hide: (): void => {
    const zen = getZen();
    if (zen) zen("webWidget", "hide");
  },
  showHelp: (): void => {
    const zen = getZen();
    if (zen) {
      zen("webWidget", "updateSettings", {
        webWidget: {
          position: { horizontal: "left", vertical: "bottom" },
          contactForm: {
            suppress: false,
          },
          helpCenter: {
            suppress: false,
          },
        },
      });
      zen("webWidget", "show");
      zen("webWidget", "open");
    }
  },
  registerHideOnClose: (): void => {
    const zen = getZen();
    if (zen) {
      zen("webWidget:on", "close", () => {
        getZen()("webWidget", "hide");
      });
    }
  },
};

export default Zendesk;
